const ALL_CLIENTS = 'all-clients';

export {
  ALL_CLIENTS,
};
